export default "__VITE_ASSET__CWoGZINc__"